/** Textos predeterminados para descargas de cualquier módulo. */
export const FILE_DOWNLOAD_RETRY_LABEL = 'Intentar de nuevo'
export const FILE_DOWNLOAD_ERROR_MESSAGE = 'Revisa tu conexión e intenta de nuevo.'
export const fileDownloadLimitMessage = (limit) => `Ya tienes ${limit} descargas en curso`
export const activityDownloadLimitHelp = (limit) =>
  `Tienes ${limit} descargas en curso. Espera a que termine una.`

export const FILE_DOWNLOAD_TOAST_MESSAGES = {
  loading: (item) => ({
    title: 'Preparando archivo…',
    message: item.title ? `${item.title}.` : 'La descarga está en preparación.'
  }),
  empty: {
    title: 'Sin registros para descargar',
    message: 'No hay datos para los filtros seleccionados. No se descargó ningún archivo.'
  },
  error: (item) => ({
    title: 'No pudimos descargar el archivo',
    message: item.message || FILE_DOWNLOAD_ERROR_MESSAGE
  }),
  success: (item) => ({
    title: 'Archivo generado',
    message: item.message || 'El archivo está listo y se envió al navegador.'
  })
}
